import React, { Component } from 'react'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import TSelect from '../../common/TSelect'
import TButton from '../../common/TButton'
import TInputForm from "../../common/TInputForm";
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import {addPrefix} from "../../../utils/UriUtil";
import {TISTORY} from "../../../constants/Service"

@connect(state => ({
}), dispatch => ({
  dispatch
}))
class ContentSettingForm extends Component {
  constructor(props) {
    super(props);

    const showCCLOption = (props.data.selected.useCCL == 1);
    this.state = {
      optionList : props.data.optionList,
      initialSelected : props.data.selected,
      selected: props.data.selected,
      changed : {},
      showCCLOption : showCCLOption,
    };
  }

  @autobind
  changeSelection(property, value) {

    const { selected, changed }= this.state;
    let diff = {};
    diff[property] = value;

    this.checkLayerToggle(property, value);

    this.setState({
      selected : Object.assign({}, selected, diff),
      changed : Object.assign({}, changed, diff),
    });
  }

  @autobind
  checkLayerToggle(property, value) {

    let layerToggle = {};

    if(property === 'useCCL') {
      if(value == 1)
        layerToggle['showCCLOption'] = true;
      else
        layerToggle['showCCLOption'] = false;
    }

    this.setState(layerToggle);
  }

  @autobind
  handleSave(successCallback, failCallback){

    const { dispatch } = this.props;
    let { selected, changed } = this.state;
    changed['CCL_commercial'] = selected['CCL_commercial'];
    changed['contentsModify'] = selected['contentsModify'];

    fetch(addPrefix("/manage/setting/contents"),
      {
        method: 'put',
        credentials: 'include',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify(this.state.changed)
      })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        successCallback();
        this.setState({
          initialSelected : this.state.selected
        });
      })
      .catch(e => {
        failCallback();
        console.log(e);
      });
  }

  @autobind
  contentWidthChange(contentWidth) {

    const { selected, changed }= this.state;

    if(parseInt(contentWidth) > 0){
      const change = { contentWidth : contentWidth};

      this.setState({
        selected : Object.assign({}, selected, change),
        changed : Object.assign({}, changed, change),
      });
    }
  }

  render() {
    const { optionList, initialSelected, selected, changed, showCCLOption } = this.state;
    const { contentWidth } = selected;

    const useKeditor = (changed['useKeditor'] == undefined && selected['useKeditor'] == 1) || changed['useKeditor'] == 1

    return (
      <form className="wrap_set">
        <fieldset>
          <legend className="screen_out">글 기본 설정</legend>
          {window.Config.service === TISTORY &&
            <div className="item_set">
              새로운 글쓰기를 <TSelect defaultClassName={'opt_set opt_ccl1'} selectItem={this.changeSelection} propertyName={'useKeditor'} selected={selected} optionList={optionList} />
            </div>
          }

          <div className="item_set">
            글쓰기 시 기본으로 저장할 글 상태는
            <TSelect defaultClassName={'opt_set opt_post1'} selectItem={this.changeSelection} propertyName={"visibilityType"} selected={selected} optionList={optionList} />
            로 설정합니다.
          </div>
          {!useKeditor &&
          <>
            <div className="item_set">
              에디터에서 속성이 없는 글씨를 보여줄 때 글꼴은
              <TSelect defaultClassName={'opt_set opt_post2'} selectItem={this.changeSelection} propertyName={"editorFont"} selected={selected} optionList={optionList} />
              크기는
              <TSelect defaultClassName={'opt_set opt_post3'} selectItem={this.changeSelection} propertyName={"editorFontSize"} selected={selected} optionList={optionList} />
              pt로 표시합니다.
            </div>
            <div className="item_set">
              에디터 가로폭은
              <TInputForm type="number" min="1" className={'tf_set tf_set1'}
                          value={contentWidth} onChange={this.contentWidthChange}/>
              px로 설정합니다.
            </div>
          </>
          }
          <div className="item_set">
            단락 앞뒤에 공백을
            <TSelect defaultClassName={'opt_set opt_ccl1'} selectItem={this.changeSelection} propertyName={"uselessMargin"} selected={selected} optionList={optionList} />
          </div>
        </fieldset>
        <fieldset>
          <legend className="screen_out">저작물 사용 허가(CCL) 설정</legend>
          <div className="item_set">
            저작물 사용 허가(CCL)를
            <TSelect defaultClassName={'opt_set opt_ccl1'} selectItem={this.changeSelection} propertyName={"useCCL"} selected={selected} optionList={optionList} />
          </div>
          <div className="item_set item_sub" style={ { display: (showCCLOption)? 'block': 'none' } }>
            상업적 이용을
            <TSelect defaultClassName={'opt_set opt_ccl2'} selectItem={this.changeSelection} propertyName={"CCL_commercial"} selected={selected} optionList={optionList} />
            합니다.
          </div>
          <div className="item_set item_sub" style={ { display: (showCCLOption)? 'block': 'none' } }>
            콘텐츠 변경을
            <TSelect defaultClassName={'opt_set opt_ccl3'} selectItem={this.changeSelection} propertyName={"contentsModify"} selected={selected} optionList={optionList} />
            합니다.
          </div>
        </fieldset>
        {!useKeditor &&
        <fieldset>
          <legend className="screen_out">지도 소개 설정</legend>
          <div className="item_set">
            다음 지도로 보낸 글 하단에 지도 위젯(장소명과 지도 링크)을
            <TSelect defaultClassName={'opt_set opt_map1'} selectItem={this.changeSelection} propertyName={"showlocalsearchtag"} selected={selected} optionList={optionList} />
          </div>
        </fieldset>
        }
        <fieldset>
          <legend className="screen_out">저장 버튼</legend>
          <TButton onClick={this.handleSave} initialValues={initialSelected} currentValues={selected}/>
        </fieldset>
      </form>
    );
  }
}

export default ContentSettingForm
